/**
 * Renders an SVG icon as a CSS mask so its colour can be driven by a CSS variable
 * (e.g. the tenant's --journey-leg-icon-color) instead of shipping light/dark variants.
 * The colour is applied via `background-color` on `.themed-icon` in SCSS.
 */
const ThemedIcon = ({ src, className = "", alt = "" }) => (
    <span
        className={`themed-icon ${className}`.trim()}
        role={alt ? "img" : "presentation"}
        aria-label={alt || undefined}
        aria-hidden={alt ? undefined : true}
        style={{ "--icon-url": `url("${src}")` }}
    />
);

export default ThemedIcon;
